import api from '../api';

export const getConversionsByToken = (token) =>
	api({
		method: 'get',
		url: `conversions/${token}`
	});
